export const CVSS4_ATTACK_VECTOR = [
  { label: 'Network (N)', value: 'N' },
  { label: 'Adjacent (A)', value: 'A' },
  { label: 'Local (L)', value: 'L' },
  { label: 'Physical (P)', value: 'P' },
] as const;

export const CVSS4_ATTACK_COMPLEXITY = [
  { label: 'Low (L)', value: 'L' },
  { label: 'High (H)', value: 'H' },
] as const;

export const CVSS4_ATTACK_REQUIREMENTS = [
  { label: 'None (N)', value: 'N' },
  { label: 'Present (P)', value: 'P' },
] as const;

export const CVSS4_PRIVILEGES_REQUIRED = [
  { label: 'None (N)', value: 'N' },
  { label: 'Low (L)', value: 'L' },
  { label: 'High (H)', value: 'H' },
] as const;

export const CVSS4_USER_INTERACTION = [
  { label: 'None (N)', value: 'N' },
  { label: 'Passive (P)', value: 'P' },
  { label: 'Active (A)', value: 'A' },
] as const;

export const CVSS4_IMPACT_METRICS = [
  { label: 'None (N)', value: 'N' },
  { label: 'Low (L)', value: 'L' },
  { label: 'High (H)', value: 'H' },
] as const;
